<template>
    <div class="main">
        <div class="tag">
            <span :class="{active:active==0}" @click="active=0">我的项目</span>
            <span :class="{active:active==1}" @click="active=1">已发布项目</span>
        </div>
        <div v-if="active==0">
            <div class="newbtn"><el-button type="primary" @click="dialogFormVisible=true">创建新项目</el-button></div>
            <div class="project">
                <!-- <div class="add" @click="dialogFormVisible=true"><img src="../assets/images/add.png" alt=""><div>创建新项目</div></div> -->
                <div class="item" v-for="(item,index) in list" @click="getDetail(item)" :key="index">
                    <div class="img"><img :src="$store.state.token.path+item.thumbnail" alt=""></div>
                    <div class="handle">
                        <div class="name">{{item.name}}<img src="../assets/images/del.png" alt="" @click.stop="deleteItem(item)"><img src="../assets/images/edit.png" alt="" @click.stop="update(item)"></div>
                        <span>{{item.desc}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="project">
            <issueProject></issueProject>
        </div>
        <el-dialog title="创建项目" :visible.sync="dialogFormVisible" width="636rem" :close-on-click-modal="false" :before-close="handleClose">
            <el-form :model="form" label-position="left" :rules="rules" ref="form">
                <el-form-item label="项目名称" :label-width="formLabelWidth">
                    <el-input v-model="form.name" autocomplete="off" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="项目描述" :label-width="formLabelWidth">
                    <el-input v-model="form.desc" type="textarea" autocomplete="off" placeholder="请输入项目描述"></el-input>
                </el-form-item>
                <el-form-item label="缩略图" :label-width="formLabelWidth" v-if="!updateState">
                    <div class="upload">
                        <el-upload
                            class="avatar-uploader"
                            action="https://local.vrmaker.vip:37086/user/set/avatar/"
                            :show-file-list="false"
                            :auto-upload="false"
                            accept=".png,.jpge,.jpg"
                            :on-change="progress"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" width="100%" height="100%">
                            <div v-else>
                                <img src="../assets/images/upload.png" alt="" class="icon">
                                <div class="img">上传项目缩略图</div>
                            </div>
                        </el-upload>
                        <!-- <img src="../assets/images/upload.png" alt="">
                        <div class="img">上传项目缩略图</div> -->
                    </div>
                    <div class="tips">支持jpg、jpeg、png格式，大小不超过2MB。</div>
                </el-form-item>
            </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="submitForm('form')" round style="width:240px" v-if="!updateState">创建</el-button>
                    <el-button type="primary"  @click="updateForm('form')" round style="width:240px" v-if="updateState">修改</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>
    import {
        getProjectList,getNewProject,deleteProject,updateProject
    } from "../api/common"
    import issueProject from "../components/issueProject.vue"
    export default {
        name: "SubstationManagement",
        components:{
            issueProject
        },
        data() {
            return {
                active:0,
                dialogFormVisible: false,
                form: {
                    name: '',
                    desc: ''
                },
                formLabelWidth: '90px',
                list:[],
                imageUrl: '',
                file:"",
                rules: {
                    name: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                    desc: [
                        { required: true, message: '请输入项目描述', trigger: 'blur' }
                    ],
                },
                updateState:false,
            }
        },
        watch: {

        },
        mounted() {
            this.getProject();
        },
        methods: {
            handleClose(done) {
                this.form.name = ""
                this.form.desc = ""
                this.file = ""
                this.imageUrl = ""
                done();
            },
            getDetail(item){
                 this.$router.push({
                    path:'/FileList',
                    name:'FileList',
                    query:{id:item.id}
                })
            },
            updateForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        name: this.form.name,
                        desc: this.form.desc,
                        id:this.form.id
                    }
                    updateProject(obj).then((res) => {
                        if (res.data.code==200) {
                            this.$message({
                                showClose: true,
                                message: '恭喜你，修改成功！',
                                type: 'success'
                            });
                            this.getProject();
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            update(item){
                this.updateState = true
                this.form = item
                this.imageUrl = this.BASE_URL+item.thumbnail;
                this.dialogFormVisible = true
            },
            deleteItem(item){
                deleteProject(item.id).then((res) => {
                    if (res.data.code==200) {
                        this.$message({
                            showClose: true,
                            message: '删除成功！',
                            type: 'success'
                        });
                        this.getProject();
                    }
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        name: this.form.name,
                        desc: this.form.desc,
                        thumbnail:this.file
                    }
                    getNewProject(obj.name,obj.desc,this.file).then((res) => {
                        if (res.data.code==200) {
                            this.$message({
                                showClose: true,
                                message: '恭喜你，创建成功！',
                                type: 'success'
                            });
                            this.getProject();
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            getProject(){
                let pageNo = 1
                let pageSize = 10
                getProjectList(pageNo,pageSize).then((res) => {
                    this.list = res.data.data.content;
                    this.dialogFormVisible = false
                })
            },
            progress(res,file){
                this.file = res.raw
                this.imageUrl = this.getObjectURL(res.raw)
            },
            getObjectURL(file) {
                var url = null ; 
                if (window.createObjectURL!=undefined) { // basic
                    url = window.createObjectURL(file) ;
                } else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file) ;
                } else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file) ;
                }
                return url ;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            }
        }
    };
</script>
<style scoped lang="less">
.main{
    padding: 5vh 10vw;
    overflow: hidden;
    .tag{
        font-size: 18rem;
        line-height: 30px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        span{
            padding: 3px 10px;
            position: relative;
            cursor: pointer;
        }
        .active::before{
            content: "";
            border-bottom: 2px solid #0D94FF;
            position: absolute;
            bottom: -3px;
            width: 40px;
            left: 50%;
            margin-left: -20px;
            z-index: 9;
            display: inline-block;
        }
    }
}
    .project{
        width: 110%;
        overflow: hidden;
        padding-bottom: 23px;
    }
    .newbtn{
        margin-top: 20px;
    }
    .upload{
        height: 240rem;
        background: #EEEEEE;
        border: 1px solid #DCDCDC;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        .icon{
            margin-top: 50rem;
        }
        /deep/.avatar-uploader{
            height: 100%;
        }
        /deep/.el-upload{
            width: 100%;
            height: 100%;
        }
    }
    .add{
        width: 19vw;
        height: 290px;
        border-radius: 12px;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        text-align: center;
        font-size: 18px;
        color: #999999;
        text-align: center;
        cursor: pointer;
        img{
            color: #D2D2D2;
            width: 52px;
            margin-top: 80px;
        }
        &>div{
            margin-top: 20px;
        }
    }
    .item{
        width: 19vw;
        height: 290px;
        overflow: hidden;
        border-radius: 12rem;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        display: inline-block;
        cursor: pointer;
        transition:all .5s;-webkit-transition:all .5s;-ms-transition:all .5s;
        .img{
            height: 200px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .handle{
            padding: 10px 10px;
            .name{
                font-size: 18px;
                margin-bottom: 10px;
                img{
                    width: 18px;
                    float: right;
                    margin-left: 20px;
                    cursor: pointer;
                    display: none;
                }
            }
            span{
                font-size: 16rem;
                color: #666;
                display: inline-block;
            }
        }
    }
        .item:hover{
            -webkit-transform: translateY(-20px);
            -moz-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
            transform: translateY(-20px);
            .name img{
                display: inline-block;
            }
        }
</style>


// WEBPACK FOOTER //
// src/views/SubstationManagement.vue